import type { ReactNode } from "react";

/** Branded fallback panel for error boundaries (error.tsx files). */
export function ErrorCard({
  title = "Something went wrong",
  body = "The page hit an unexpected error. Your books and notes are safe — this is on us.",
  digest,
  action,
}: {
  title?: string;
  body?: string;
  digest?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center rounded-[16px] border border-dashed border-border bg-surface/50 px-6 py-16 text-center">
      <div className="mb-4 flex h-[44px] w-[44px] items-center justify-center rounded-full bg-copper-light-3 text-[20px]">
        <span aria-hidden="true">⚠</span>
      </div>
      <h2 className="font-serif text-[22px] font-medium text-ink">{title}</h2>
      <p className="mt-2 max-w-sm text-[15px] text-muted">{body}</p>
      {action && <div className="mt-6 flex items-center gap-3">{action}</div>}
      {digest && (
        <p className="mt-4 text-[11px] text-muted-3">
          Error reference: <code className="font-mono">{digest}</code>
        </p>
      )}
    </div>
  );
}
